import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === "en";
  const [visible, setVisible] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("auria_cookie_consent");
    if (!consent) {
      setVisible(true);
      // Small delay for smooth entry animation
      setTimeout(() => setShow(true), 200);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("auria_cookie_consent", "all");
    setShow(false);
    setTimeout(() => setVisible(false), 300);
  };

  const handleReject = () => {
    localStorage.setItem("auria_cookie_consent", "essential");
    setShow(false);
    setTimeout(() => setVisible(false), 300);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[200] p-4 transition-all duration-300 ${
        show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
    >
      <div className="max-w-5xl mx-auto bg-stone-900 rounded-2xl px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-5 border border-white/10">
        {/* Icon */}
        <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-amber-500/20 flex-shrink-0">
          <i className="ri-cookie-line text-amber-400 text-lg" />
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0">
          <p className="text-white text-sm font-bold mb-1">
            {t("cookie_title")}
          </p>
          <p className="text-stone-400 text-xs leading-relaxed">
            {t("cookie_desc")}{" "}
            <Link
              to="/privacidad"
              className="text-amber-400 hover:text-amber-300 underline cursor-pointer transition-colors"
            >
              {t("cookie_policy")}
            </Link>
          </p>
        </div>

        {/* Buttons */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={handleReject}
            className="px-4 py-2 text-xs font-semibold text-stone-300 hover:text-white border border-stone-600 hover:border-stone-400 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("cookie_reject")}
          </button>
          <button
            onClick={handleAccept}
            className="px-5 py-2 text-xs font-bold text-stone-900 bg-amber-400 hover:bg-amber-300 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("cookie_accept")}
          </button>
        </div>

        {/* Close X */}
        <button
          onClick={handleReject}
          title={isEn ? "Close" : "Cerrar"}
          className="absolute top-3 right-3 sm:static w-6 h-6 flex items-center justify-center text-stone-500 hover:text-stone-300 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-sm" />
        </button>
      </div>
    </div>
  );
}
